@if (view$ | async; as view) {
    <span class="form-label">
        {{ 'monitoring_I-want-to-monitor-the-following-consumption' | translate }}
    </span>

    @for (consumptionToMonitor of view.consumptionToMonitors; track consumptionToMonitor.type) {
        <div class="d-flex justify-content-between">
            <div class="form-check ms-3">
                <input
                    type="radio"
                    class="form-check-input"
                    name="consumptionToMonitor"
                    (click)="consumptionToMonitorClicked($event, view.formGroup)"
                    [formControl]="view.formGroup.controls.consumptionToMonitor"
                    [id]="consumptionToMonitor.type"
                    [value]="consumptionToMonitor.type" />
                <label class="form-check-label" [for]="consumptionToMonitor.type">
                    {{ consumptionToMonitor.translationKey | translate }}
                </label>
            </div>

            <app-tooltip [popover]="consumptionToMonitor.descriptionKey | translate" />
        </div>
    }

    @if (view.metersForAgentData.loading === false) {
        @if (view.meterSettingsFormGroup.invalid) {
            <div class="d-flex justify-content-end mt-3">
                <button
                    class="btn btn-outline-primary btn-sm"
                    type="button"
                    (click)="selectMeters(view.formGroup, view.metersForAgentData.value)">
                    {{ 'common_SELECT_METERS' | translate }}
                </button>
            </div>
        } @else {
            <div class="border p-3 mt-3" style="margin-left: 40px">
                <div class="row">
                    <span class="col-6 form-label m-0">
                        {{ 'monitoring_meterType' | translate }}
                    </span>
                    <span class="col-6 text-end">
                        {{
                            'mappers_meterType.' +
                                view.meterSettingsFormGroup.value.meterSuperTypeNo
                                | translate: 'online' : 'common'
                        }}
                    </span>
                </div>
                <div class="row">
                    <span class="col-6 form-label m-0">
                        {{ 'monitoring_usageAndUnits' | translate }}
                    </span>

                    <span class="col-6 text-end">
                        @for (
                            selectableUsageAndUnit of view.meterSettingsFormGroup.value
                                .selectableUsageAndUnits;
                            track selectableUsageAndUnit.name
                        ) {
                            @if (selectableUsageAndUnit.selected) {
                                <div>
                                    {{ selectableUsageAndUnit.name }}
                                </div>
                            }
                        }
                    </span>
                </div>
                <div class="row">
                    <span class="col-6 form-label m-0">
                        {{ 'utilities_output_unit' | translate }}
                    </span>
                    <span class="col-6 text-end">
                        {{
                            'mappers_measurementUnit.' +
                                view.meterSettingsFormGroup.value.outputUnit
                                | translate: 'online' : 'common'
                        }}
                    </span>
                </div>

                @if (view.meterIdGroupsFormGroup; as meterIdGroups) {
                    <div class="row">
                        <span class="col-6 form-label m-0">
                            {{ 'utilities_group1' | translate }}
                        </span>
                        <span class="col-6 text-end">
                            {{ view.meterSettingsFormGroup.value.groupName }}
                        </span>
                    </div>
                    @if (meterIdGroups.controls.idsInGroup2.enabled) {
                        <div class="row">
                            <span class="col-6 form-label m-0">
                                {{ 'utilities_group2' | translate }}
                            </span>
                            <span class="col-6 text-end">
                                {{ view.meterSettingsFormGroup.value.groupName2 }}
                            </span>
                        </div>
                    }
                }

                <div class="d-flex justify-content-end mt-3">
                    <button
                        type="button"
                        class="btn btn-outline-danger me-1 btn-sm"
                        (click)="deleteMeterSettings(view.formGroup)">
                        <i class="bi bi-trash"></i>
                    </button>
                    <button
                        class="btn btn-outline-primary btn-sm"
                        type="button"
                        (click)="selectMeters(view.formGroup, view.metersForAgentData.value)">
                        {{ 'properties_edit' | translate: 'online' : 'monitoringAlarms' }}
                    </button>
                </div>
            </div>
        }

        <app-control-messages [control]="view.formGroup" />
    } @else {
        <app-load />
    }
}
